<div>
  <div class="card-header">
    <div class="title-section"></div>
    <div class="button-section">
      <div class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." appPermissionControl="P105K0001" />
      </div>
      <button mat-flat-button class="btn-new" (click)="nuevo()" appPermissionControl="P105B0001">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
    </div>
  </div>

  <p-table
    #dt
    [value]="promociones"
    [columns]="columns"
    [loading]="loading"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [scrollable]="true"
    scrollHeight="350px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    appendTo="body"
    [globalFilterFields]="['sEmpresa', 'sSucursal', 'sPromocion']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P105T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="th-prime" appPermissionControl="P105C0001">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container *ngIf="col.field !== 'actions'">
            {{ rowData[col.field] }}
          </ng-container>
          <ng-container *ngIf="col.field === 'actions'">
            <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="delete(rowData)" matTooltip="Eliminar" appPermissionControl="P105B0002"></button>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer" appendTo="body"></ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>
